<template>
  <div class="mobile-recommended" v-if="showMobileRecommended">
    <button class="close" @click="showMobileRecommended = false">Fechar</button>
    <img class="bg-mobile" src="@/assets/img/bg-mobile.svg" />
    <div class="mobile-info">
      <img src="@/assets/img/logo-xs.svg" />
      <h3>App Staage</h3>
      <p class="info-text">
        Lançamos nosso aplicativo! <br />
        Baixe o aplicativo para {{ isAndroid ? 'android' : 'ios' }} e comece a assistir 🔥
      </p>
      <a
        :href="
          isAndroid
            ? 'https://play.google.com/store/apps/details?id=com.staage.android.app'
            : 'https://apps.apple.com/us/app/staage/id1588937065'
        "
        target="_blank"
        class="btn-outline"
      >
        <img :src="require(`@/assets/img/icon-${isAndroid ? 'google-play' : 'apple'}.svg`)" />
        <div class="btn-text">
          <p>Disponível em</p>
          <h4>{{ isAndroid ? 'Google Play' : 'App Store' }}</h4>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { ref, computed } from 'vue'

const store = useStore()

const showMobileRecommended = ref(false)

const isLogged = computed(() => store.getters['auth/getIsLogged'])
if (!window.location.pathname.includes('connect') && isLogged.value === true && innerWidth <= 425) {
  showMobileRecommended.value = true
}

const isAndroid = ref(false)
if (/android/i.test(navigator.userAgent)) {
  isAndroid.value = true
} else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
  isAndroid.value = false
}
</script>

<style lang="scss" scoped>
@import '@/styles/scss/_colors.scss';
.mobile-recommended {
  width: 100%;
  height: 100%;
  z-index: 2022;
  position: fixed;
  top: 0;
  background-color: $gray-scale-01;
  .close {
    font-size: 1.4rem;
    font-weight: 700;
    position: absolute;
    top: 1.4rem;
    right: 1rem;
    padding: 1rem;
  }
  .bg-mobile {
    width: 100%;
  }
  .mobile-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
    h3 {
      margin: 2.5rem 0 1.6rem;
    }
    .info-text {
      max-width: 70%;
      font-size: 1.2rem;
      text-align: center;
      line-height: 130%;
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 2.4rem;
    }
    .btn-outline {
      width: 80%;
      padding: 2.6rem 0;
      display: flex;
      gap: 1.2rem;
      p {
        font-size: 1.2rem;
      }
      .btn-text {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
